export const MuiIconButton = {
    styleOverrides: {
        root: ({ theme }) => ({
            color: theme.palette.neutral.main,
            height: 'fit-content',
        }),
    },
};
